module.exports = __webpack_public_path__ + "static/media/ominous.c5d8fb3f.mp3";